import RequisaMaterialesScreen from "../../Screen/Mantenimiento/RequisaMateriales/RequisaMaterialesScreen";

export const MantenimientoRoutes = [
    {
    path: 'Mantenimiento/RequisaMateriales',
    permiso: 149,
    element: <RequisaMaterialesScreen />
  },
]  

export default MantenimientoRoutes;